import { useMemo } from 'react';

import { ObjectTypeConfigureStep } from '@/lib/vendor-import';

import type { DiscoveredObjectType } from './api';
import {
  discoveredTypeToLightfieldObjectType,
  LIGHTFIELD_OBJECT_TYPES,
} from './constants';

export interface LightfieldConfigureStepProps {
  selected: string[];
  onChange: (names: string[]) => void;
  discoveredTypes?: DiscoveredObjectType[];
}

export function LightfieldConfigureStep({
  selected,
  onChange,
  discoveredTypes = [],
}: LightfieldConfigureStepProps) {
  const objectTypes = useMemo(
    () => [
      ...LIGHTFIELD_OBJECT_TYPES,
      ...discoveredTypes.map(discoveredTypeToLightfieldObjectType),
    ],
    [discoveredTypes]
  );

  return (
    <ObjectTypeConfigureStep
      objectTypes={objectTypes}
      selected={selected}
      onChange={onChange}
      description='Choose which record types to bring over from Lightfield.'
    />
  );
}
